import { render, staticRenderFns } from "./order-table.vue?vue&type=template&id=4f6c9275&scoped=true&"
import script from "./order-table.component.ts?vue&type=script&lang=ts&"
export * from "./order-table.component.ts?vue&type=script&lang=ts&"
import style0 from "./order-table.scss?vue&type=style&index=0&id=4f6c9275&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6c9275",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f6c9275')) {
      api.createRecord('4f6c9275', component.options)
    } else {
      api.reload('4f6c9275', component.options)
    }
    module.hot.accept("./order-table.vue?vue&type=template&id=4f6c9275&scoped=true&", function () {
      api.rerender('4f6c9275', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/last-mile-delivery-wellcome/components/order-table/order-table.vue"
export default component.exports